import { useEffect, useState } from "react";
import { PlatformFilter } from "./filter";
import { Box, Pagination, Paper, Button } from "@mui/material";
import { TypographyHeading } from "shared/molecules/typography-layout";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { table } from "./helper";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material";

import { FormControl, Select, MenuItem, InputLabel} from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import { GET_PLATFORMS_LIST } from "utils/graphql/services/live-classes/queries";
import { utcToIst } from "utils/time-util/utcIstTime";
import authClientService from "utils/graphql/authClient";

export default function Platform() {

  const [searchPayload, setSearchPayload] = useState({});
  const [page, setPage] = useState(1);
  const [clearValuesTrigger, setClearValuesTrigger] = useState(0);
  const [limit, setLimit] = useState(10);

  const [getPlatformsList, { loading, error, data }] = useLazyQuery(
    GET_PLATFORMS_LIST,
    {
      client: authClientService,
    },
  );

  useEffect(() => {
        getPlatformsList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);
  
   const platformsData =
              data?.getPlatforms?.platforms?.map((item: any) => ({
                  ...item,
                  createdAt: utcToIst(item.createdAt),
                  updatedAt: utcToIst(item.updatedAt),
              })) || [];

  return (
    <>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Platforms{" "}
      </TypographyHeading>

      <PlatformFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />

      <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <FormControl size="small" sx={{ width: 140 }}>
            <InputLabel>Show Entries</InputLabel>
            <Select
              value={limit}
              label="Show Entries"
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1); // reset to first page
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div>
          {loading && <Loader />}
          {!loading && data?.getPlatforms?.platforms?.length > 0 ? (
            
            <SectionTable
              key={limit}
              data={platformsData || []}
              table={table}
              id="id"
              name="id"
              rowsPerPageCount={limit}
              style="false"
              totalRecords={data?.getPlatforms?.totalCount || 0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
            
          ) : (
            <div>{!loading && <NoDataFound message="No Data Found" />}</div>
          )}
        </div>

        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getPlatforms?.totalCount / limit) || 1}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
        
      </Paper>
    </>
  );
}
